<script setup lang="ts">
import AppHeader from "@/components/header/AppHeader.vue";
import TaskPaneView from "@/views/TaskPaneView.vue";
</script>

<template>
  <v-app>
    <AppHeader />
    <v-main>
      <TaskPaneView />
    </v-main>
  </v-app>
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use "/src/scss/settings.scss";
</style>
